import styles from "./Search.module.scss";
import { AutoComplete, Input, Spin } from "antd";
import { useEffect, useState } from "react";
import useDebounce from "../UseDebounce/useDebounce";
import FiltersSelectedTags from "../FilterSelectedTags/FilterSelectedTags";
import { SearchOutlined } from "@ant-design/icons";

const AutoCompleteSearch = ({
  placeholder,
  functionSearch = () => {},
  filters,
  setFilters,
  entity,
  style,
  autoCompleteStyle,
  callback = null,
  hideFilterSelectedTags,
}) => {
  const [query, setQuery] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const debouncedValue = useDebounce(query);
  useEffect(() => {
    let searchController;
    if (debouncedValue) {
      if (searchController) {
        searchController.abort();
      }

      const initOption = {
        value: debouncedValue,
        name: debouncedValue,
      };
      setOptions([initOption]);
      if (debouncedValue.length > 2) {
        setLoading(true);
        searchController = functionSearch(debouncedValue, (res) => {
          setOptions([
            initOption,
            ...res.map((item) => {
              return {
                ...item,
                value: item.name ? item.name : item.value,
                name: item.name ? item.name : item.value,
              };
            }),
          ]);
          setLoading(false);
        });
      }
    }

    return () => {
      if (searchController) {
        searchController.abort();
      }
    };
  }, [debouncedValue]);
  const handleInputChange = (value) => {
    setQuery(value);
  };
  const handleInputConfirm = (value, option) => {
    setFilters({
      ...filters,
      [`${entity}`]: `${option.name}`,
    });
    if (callback) {
      callback();
    }
  };
  const handleInputEnter = () => {
    setFilters({ ...filters, [`${entity}`]: query });
    if (callback) {
      callback();
    }
  };
  return (
    <div className={styles["search-container"]}>
      <AutoComplete
        options={options}
        placeholder={placeholder}
        onChange={handleInputChange}
        onSelect={handleInputConfirm}
        style={{ width: "100%", ...autoCompleteStyle }}
        dropdownRender={(menu) =>
          isLoading ? (
            <div style={{ height: "200px", padding: "12px" }}>
              <Spin />
            </div>
          ) : (
            <>{menu}</>
          )
        }
      >
        <Input
          style={style}
          onPressEnter={handleInputEnter}
          suffix={<SearchOutlined />}
        />
      </AutoComplete>

      {!hideFilterSelectedTags && (
        <FiltersSelectedTags
          filters={{ [entity]: filters[entity] }}
          setFilters={setFilters}
        />
      )}
    </div>
  );
};

export default AutoCompleteSearch;
